export const Payment = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="9" width="22" height="12" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M30 11V23C30 24.1046 29.1046 25 28 25H6" stroke="currentColor" stroke-width="2"/>
<circle cx="15" cy="15" r="2" stroke="currentColor" stroke-width="2"/>
</svg>`;
